module.exports = __webpack_public_path__ + "static/media/4.11_preview.cf1cba29.png";